import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context1, _context10; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context1 = ownKeys(Object(t), !0)).call(_context1, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context10 = ownKeys(Object(t))).call(_context10, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
import _Number$isFinite from "@babel/runtime-corejs3/core-js-stable/number/is-finite";
import _Math$trunc from "@babel/runtime-corejs3/core-js-stable/math/trunc";
import _parseFloat from "@babel/runtime-corejs3/core-js-stable/parse-float";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
/** The blank display for an empty value. */
export var EM_DASH = "—";
export function convertToOrdinal(n) {
  if (n == null) return null;
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}
export function abbreviateNumber(number) {
  var _context, _context2;
  var round = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  /*
      solution derived from https://stackoverflow.com/a/48587119
  */
  var SI_PREFIXES = [{
    value: 1,
    symbol: ""
  }, {
    value: 1e3,
    symbol: "K"
  }, {
    value: 1e6,
    symbol: "M"
  }, {
    value: 1e9,
    symbol: "B"
  }, {
    value: 1e12,
    symbol: "T"
  }, {
    value: 1e15,
    symbol: "P"
  }, {
    value: 1e18,
    symbol: "E"
  }];
  if (!number) return null;
  var isNeg = number <= 0;
  if (isNeg) {
    number = number * -1;
  }
  var tier = _filterInstanceProperty(SI_PREFIXES).call(SI_PREFIXES, function (n) {
    return number >= n.value;
  }).pop();
  if (!tier) {
    return null;
  }
  var numberFixed = (number / tier.value).toFixed(1);
  if (numberFixed.substr(-1) === "0" || round) {
    numberFixed = numberFixed.substr(0, numberFixed.length - 2);
  }
  return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "".concat(isNeg ? "–" : "")).call(_context2, numberFixed)).call(_context, tier.symbol);
}
/**
 * Parses a numeric value or `null` out of whatever the caller has. A blank, absent, or non-numeric
 * value is `null`, never `NaN` — callers never have to guard the result before sending it to a
 * mutation. Thousands separators are stripped, so a pasted `"1,200"` parses the same as `"1200"`.
 *
 * Two kinds of caller, hence the wide parameter:
 *  - **free-typed input** — a table cell or form field, where the value is a string by definition;
 *  - **a GraphQL `Decimal` field** — a Django `DecimalField` reaches the frontend as a **string**
 *    (Graphene serializes `Decimal` with `str()`), while codegen has no mapping for that scalar, so
 *    the generated type is effectively `any` and nothing warns. See `docs/gotchas.md`.
 */
export function parseNumberOrNull(value) {
  var _context3;
  // Explicit, though the lines below would reach the same answer on their own (`String(null)` is
  // `"null"`, which parses to `NaN`). Intent shouldn't rest on that coincidence.
  if (value === null || value === undefined) return null;
  var trimmed = _trimInstanceProperty(_context3 = String(value)).call(_context3);
  if (trimmed === "") return null;
  var parsed = Number(trimmed.replace(/,/g, ""));
  return _Number$isFinite(parsed) ? parsed : null;
}

/** `parseNumberOrNull`, truncated to an integer. */
export function parseIntegerOrNull(value) {
  var parsed = parseNumberOrNull(value);
  return parsed == null ? null : _Math$trunc(parsed);
}
export function formatNumber(value) {
  var _context4, _context5;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$disableForma = options.disableFormatting,
    disableFormatting = _options$disableForma === void 0 ? false : _options$disableForma,
    _options$decimalCount = options.decimalCount,
    decimalCount = _options$decimalCount === void 0 ? 0 : _options$decimalCount,
    _options$displayTrail = options.displayTrailingZeros,
    displayTrailingZeros = _options$displayTrail === void 0 ? false : _options$displayTrail,
    _options$prefix = options.prefix,
    prefix = _options$prefix === void 0 ? "" : _options$prefix,
    _options$suffix = options.suffix,
    suffix = _options$suffix === void 0 ? "" : _options$suffix,
    _options$blankDisplay = options.blankDisplay,
    blankDisplay = _options$blankDisplay === void 0 ? EM_DASH : _options$blankDisplay,
    _options$zeroIsBlank = options.zeroIsBlank,
    zeroIsBlank = _options$zeroIsBlank === void 0 ? false : _options$zeroIsBlank,
    _options$displayOrdin = options.displayOrdinal,
    displayOrdinal = _options$displayOrdin === void 0 ? false : _options$displayOrdin,
    _options$abbreviate = options.abbreviate,
    abbreviate = _options$abbreviate === void 0 ? false : _options$abbreviate,
    _options$useNegForEmp = options.useNegForEmptyValue,
    useNegForEmptyValue = _options$useNegForEmp === void 0 ? false : _options$useNegForEmp;
  var isBlank = value == null || zeroIsBlank && value === 0 || isNaN(value);
  if (isBlank) {
    return useNegForEmptyValue ? "Neg." : blankDisplay;
  }
  var display = value;
  if (disableFormatting) {
    display = value;
  } else if (displayOrdinal) {
    display = convertToOrdinal(value);
  } else if (abbreviate) {
    display = abbreviateNumber(value);
  } else {
    var decimalCountValue = _parseFloat(Number(value).toFixed(decimalCount));
    if (!displayTrailingZeros && decimalCountValue % 1 === 0) {
      display = Number(decimalCountValue).toLocaleString("en");
    } else {
      display = Number(value).toLocaleString("en", {
        maximumFractionDigits: decimalCount,
        minimumFractionDigits: decimalCount
      });
    }
  }
  return _concatInstanceProperty(_context4 = _concatInstanceProperty(_context5 = "".concat(prefix)).call(_context5, display)).call(_context4, suffix);
}

/** RKG-6571: a currency amount from here up reads in whole dollars; below it keeps its cents. */
export var WHOLE_DOLLAR_THRESHOLD = 10000;

/**
 * A currency amount by RKG-6571's rule: $10,000 or more in whole dollars ("$945,300"), less with
 * two decimals ("$1,234.56"). For amounts such as a sale price or a monthly rent.
 */
export function formatCurrencyAmount(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var whole = value != null && Math.abs(Number(value)) >= WHOLE_DOLLAR_THRESHOLD;
  return formatNumber(value, _objectSpread(_objectSpread({
    prefix: "$"
  }, options), {}, {
    decimalCount: whole ? 0 : 2,
    displayTrailingZeros: !whole
  }));
}

/**
 * A min/max pair with the unit stated once at the end: "5,000 - 15,000 sqft", or the one side that
 * is set. Zero counts as not captured, so `0` and `null` render the same; with neither side set
 * the result is `blankDisplay`.
 */
export function formatNumberRange(min, max, _ref) {
  var _context6;
  var suffix = _ref.suffix,
    _ref$blankDisplay = _ref.blankDisplay,
    blankDisplay = _ref$blankDisplay === void 0 ? EM_DASH : _ref$blankDisplay;
  var format = function format(value, withSuffix) {
    return formatNumber(value, {
      suffix: withSuffix ? " ".concat(suffix) : ""
    });
  };
  if (min && max) return _concatInstanceProperty(_context6 = "".concat(format(min, false), " - ")).call(_context6, format(max, true));
  if (min) return format(min, true);
  if (max) return format(max, true);
  return blankDisplay;
}

/**
 * Shared "single value, or a low–high range" display used by both the building and listing
 * flyouts' Clear Height rows (and any other range-capable industrial field): `null`/`undefined`
 * lower bound is `EM_DASH`; a real range (both `isRange` and an upper bound) prints both bounds
 * with `suffix` on each; otherwise just the lower bound. `formatNumber` supplies thousands separators.
 */
export function getRangeDisplay(lower, upper, isRange) {
  var _context0;
  var suffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
  if (!lower && lower !== 0) return EM_DASH;
  if (isRange && upper) {
    var _context7, _context8, _context9;
    return _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = "".concat(formatNumber(lower))).call(_context9, suffix, " - ")).call(_context8, formatNumber(upper))).call(_context7, suffix);
  }
  return _concatInstanceProperty(_context0 = "".concat(formatNumber(lower))).call(_context0, suffix);
}